import { getRandomId as getRandomNodeId, ROOT_NODE } from "@craftjs/utils";
import { blocksLibrary } from "../blocks";
import { waitForElement } from "../dom";

function insertInside(
  actions,
  query,
  id,
  type,
  before = false,
  document = window.document,
) {
  if (!query || !actions) {
    return;
  }

  id = id ?? query.getEvent("selected").first();
  if (!id) return;

  // If current id is not canvas, return
  if (!query.node(id)?.isCanvas()) {
    return;
  }

  const nodeID = getRandomNodeId();
  const freshNode = {
    id: nodeID,
    data: {
      type: blocksLibrary[type],
      props: {},
    },
  };
  const nodeToAdd = query.parseFreshNode(freshNode).toNode();

  // Index of the node to be inserted is lendth of childrens of the current node
  var node_index = before ? 0 : query.node(id).childNodes().length;

  actions.add(nodeToAdd, id, node_index);
  actions.selectNode(nodeID);

  waitForElement(
    document,
    `[data-grigora-block-id='${nodeID}'] .grigora-richtext-input__field`,
  ).then((elm) => {
    elm.focus();
  });
}

export default insertInside;
